import React from "react";
import { Form } from "react-final-form";

import { Dialog } from "../../../../../../../components/dialogs/Dialog/Dialog";
import { Button } from "../../../../../../../components/Buttons/Button/Button";

import TemplateSelectorFormFields from "./TemplateSelectorFormFields";

import styles from "./styles.module.scss";

const UpdateTemplateSelectorDialog = ({ isOpen, initialValues, onClose, onSubmitFormDialog }) => (
    <Dialog
        classes={{ paper: styles.updateTemplateSelector }}
        title="Template"
        isOpen={isOpen}
        onClose={onClose}
    >
        <Form
            onSubmit={onSubmitFormDialog}
            initialValues={initialValues}
            render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                    <TemplateSelectorFormFields />

                    <div className={styles.commands}>
                        <Button
                            className={styles.btn}
                            colorFirm={2}
                            type="submit"
                        >
                            Save
                        </Button>

                        <Button
                            className={styles.btn}
                            colorFirm={3}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </div>
                </form>
            )}
        />
    </Dialog>
);

export default UpdateTemplateSelectorDialog;
